"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var utils_1 = require("../utils");
var useColumns = function (columns, columnsSetting) {
    var _a = (0, react_1.useState)([]), columnsState = _a[0], setColumnsState = _a[1];
    (0, react_1.useEffect)(function () {
        setColumnsState((0, utils_1.setStatusVisibleColumns)((0, utils_1.sortColumns)(columns, columnsSetting), columnsSetting));
        // eslint-disable-next-line
    }, [columns]);
    return { columnsState: columnsState, setColumnsState: setColumnsState };
};
exports.default = useColumns;
